import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * TopicsDialog - Modal dialog for selecting extra topics for a project
 * Shows "No task to select" message when no topics are available
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {function} props.onClose - Function to call when dialog should close
 * @param {Array} props.topics - Array of available topics to select
 * @param {function} props.onAddTopics - Function called when Add Topics button is clicked
 */
const TopicsDialog = ({
  open,
  onClose,
  topics = [],
  onAddTopics
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '4px',
          margin: 'auto',
          maxHeight: '90vh',
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 'calc(100% - 32px)'
        }
      }}
    >
      {/* Dialog Title with Close Button */}
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          pb: 2,
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '1rem' }}>
          Select extra topics to activate for your project
        </Typography>
        <IconButton
          edge="end"
          onClick={onClose}
          aria-label="close"
          size="small"
          sx={{
            color: '#9e9e9e',
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#666'
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent sx={{ p: 0, minHeight: '150px' }}>
        {topics.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {/* Here would go the list of topics/tasks to select */}
            {topics.map((topic, index) => (
              <Box key={index} sx={{ py: 1 }}>
                {topic.title}
              </Box>
            ))}
          </Box>
        ) : (
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              height: '100%',
              minHeight: '100px',
              p: 4
            }}
          >
            <Typography color="text.secondary" sx={{ fontSize: '0.9rem' }}>
              No task to select
            </Typography>
          </Box>
        )}
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions sx={{ p: 1, justifyContent: 'flex-end', borderTop: '1px solid rgba(0, 0, 0, 0.05)' }}>
        <Button
          variant="contained"
          onClick={onAddTopics}
          sx={{
            bgcolor: '#ba68c8',
            color: 'white',
            '&:hover': {
              bgcolor: '#9c27b0',
            },
            borderRadius: '4px',
            textTransform: 'none',
            px: 3,
            py: 1,
            fontSize: '0.9rem'
          }}
        >
          Add topics
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TopicsDialog;